module.exports = __webpack_public_path__ + "assets/img/62e7-bn.svg";